module.exports = __webpack_public_path__ + "img/suitability_border.fee61c58.svg";